import { SpaceProps } from 'styled-system';
import { convertPropsToStyle } from './properties';

const SPACE_PROPS = [
  'marginTop',
  'marginRight',
  'marginLeft',
  'marginBottom',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
];

/**
 * Position related styles for styled components
 *
 * @param props - render props
 */
export const space = convertPropsToStyle<SpaceProps>(SPACE_PROPS);
